import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import SEO from '../components/SEO';

const TermsPage = () => {
  return (
    <main className="min-h-screen bg-white pt-20">
      <SEO
        title="Termeni și Condiții"
        url="https://seltz.eu/terms"
        description="Termenii și Condițiile de utilizare aferente Seltz Vodka Soda."
      />
      {/* Hero */}
      <section
        className="py-16 text-center"
        style={{ background: 'linear-gradient(145deg, #0f0f0f 0%, #0a0a0a 100%)' }}
      >
        <h1
          className="text-white font-black italic mb-3"
          style={{ fontFamily: 'Nunito, sans-serif', fontSize: 'clamp(2.5rem, 5vw, 4rem)' }}
        >
          termeni și condiții
        </h1>
        <p className="text-white/70 text-sm" style={{ fontFamily: 'Nunito, sans-serif' }}>
          Ultima actualizare: Iulie 2025
        </p>
      </section>

      {/* Content */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-6 lg:px-12">
          {/* Breadcrumb */}
          <div className="flex items-center gap-2 text-sm text-gray-400 mb-10" style={{ fontFamily: 'Nunito, sans-serif' }}>
            <Link to="/" className="hover:text-[#0a0a0a] transition-colors">Acasă</Link>
            <ChevronRight size={14} />
            <span className="text-[#0a0a0a] font-bold">Termeni și Condiții</span>
          </div>

          <div className="prose prose-blue max-w-none space-y-10" style={{ fontFamily: 'Nunito, sans-serif' }}>

            <Section title="1. Acceptarea Termenilor">
              <p>Prin accesarea și utilizarea site-ului Seltz Vodka Soda, confirmați că aveți cel puțin 18 ani (sau vârsta legală minimă pentru consum de alcool în țara dumneavoastră) și că sunteți de acord cu acești Termeni și Condiții. Dacă nu sunteți de acord cu oricare dintre aceste condiții, vă rugăm să nu utilizați site-ul nostru.</p>
            </Section>

            <Section title="2. Restricție de Vârstă">
              <p>Seltz Vodka Soda este un produs alcolic. Accesul pe acest site este strict limitat la persoanele cu vârsta legală de consum de alcool în jurisdicția lor. Prin utilizarea acestui site, declarați că aveți vârsta legală minimă necesară.</p>
              <p className="mt-3">Nu promovăm consumul iresponsabil de alcool. Beți cu moderație.</p>
            </Section>

            <Section title="3. Proprietatea Intelectuală">
              <p>Tot conținutul publicat pe acest site, inclusiv dar fără a se limita la texte, grafică, logo-uri, imagini, clipuri audio și videoclipuri, este proprietatea Seltz Spirits LLC sau a licențiatorilor săi și este protejat de legile privind drepturile de autor și mărcile comerciale.</p>
              <p className="mt-3">Este interzisă reproducerea, distribuirea sau utilizarea în alt scop a conținutului fără acordul prealabil scris al Seltz Spirits LLC.</p>
            </Section>

            <Section title="4. Utilizarea Site-ului">
              <p>Sunteți de acord să utilizați site-ul nostru numai în scopuri legale. Este interzis:</p>
              <ul className="list-disc pl-6 mt-3 space-y-2">
                <li>Utilizarea site-ului în mod care ar putea deteriora, dezactiva sau supraîncărca serverele noastre</li>
                <li>Tentativele de acces neautorizat la orice parte a site-ului</li>
                <li>Utilizarea roboților, spider-ilor sau altor instrumente automate pentru colectarea datelor</li>
                <li>Transmiterea oricărui material ilegal, dăunător sau ofensator</li>
              </ul>
            </Section>

            <Section title="5. Produse și Prețuri">
              <p>Ne rezervăm dreptul de a modifica oricând prețurile, descrierile produselor și disponibilitatea acestora fără notificare prealabilă. Toate prețurile sunt afișate în USD și nu includ taxele locale sau costurile de livrare, dacă este cazul.</p>
              <p className="mt-3">Imaginile produselor sunt prezentate cu titlu ilustrativ. Produsul final poate prezenta ușoare diferențe față de imaginile afișate.</p>
            </Section>

            <Section title="6. Comenzi și Livrare">
              <p>Prin plasarea unei comenzi, acceptați că produsele vor fi livrate doar la adrese unde consumul de alcool este legal. Ne rezervăm dreptul de a refuza sau anula orice comandă din motive justificate, inclusiv suspiciunea de achiziție pentru minori.</p>
              <p className="mt-3">Livrarea se face prin parteneri logistici autorizați. Timpii de livrare sunt estimativi și pot varia în funcție de locație și disponibilitate.</p>
            </Section>

            <Section title="7. Retururi și Rambursări">
              <p>Dacă produsul primit este deteriorat sau incorect, vă rugăm să ne contactați în termen de 48 de ore de la primire la adresa de email indicată în secțiunea Contact. Vom analiza fiecare caz individual și vom oferi soluția adecvată (înlocuire sau rambursare).</p>
              <p className="mt-3">Produsele deschise sau consumate parțial nu sunt eligibile pentru retur.</p>
            </Section>

            <Section title="8. Limitarea Răspunderii">
              <p>Seltz Spirits LLC nu va fi responsabilă pentru niciun fel de daune directe, indirecte, incidentale sau consecvente care pot apărea din utilizarea sau imposibilitatea utilizării site-ului sau a produselor noastre.</p>
            </Section>

            <Section title="9. Legea Aplicabilă">
              <p>Acești termeni sunt guvernați de legile Statelor Unite ale Americii și ale statului California. Orice dispută va fi soluționată în instanțele competente din Los Angeles, California.</p>
            </Section>

            <Section title="10. Modificări ale Termenilor">
              <p>Ne rezervăm dreptul de a modifica acești termeni în orice moment. Modificările vor intra în vigoare imediat după publicarea pe site. Continuarea utilizării site-ului după publicarea modificărilor constituie acceptarea acestora.</p>
            </Section>

            <Section title="11. Contact">
              <p>Pentru orice întrebări legate de acești termeni, ne puteți contacta prin pagina noastră de <Link to="/contact" className="text-[#0a0a0a] font-bold underline">contact</Link> sau la adresa noastră de email.</p>
            </Section>
          </div>
        </div>
      </section>
    </main>
  );
};

const Section = ({ title, children }) => (
  <div className="border-b border-gray-100 pb-8">
    <h2
      className="text-[#0a0a0a] font-black italic text-xl mb-4"
      style={{ fontFamily: 'Nunito, sans-serif' }}
    >
      {title}
    </h2>
    <div className="text-gray-600 leading-relaxed text-sm space-y-3">
      {children}
    </div>
  </div>
);

export default TermsPage;
